export default "__VITE_ASSET__ab1d3b6c__"